module.exports = __webpack_public_path__ + "static/img/logo-footer.a8e8596.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-footer.png
// module id = +PBE
// module chunks = 1